<script lang="ts" setup>
import { ref } from 'vue'
import { getDateFormatted, getTimeFormatted12Hours } from '@/services/date'
import { mdiCalendarCheckOutline, mdiClockOutline } from '@mdi/js'
import { IEventEdit } from '@/enitites/event'

const props = defineProps<{
  eventData: IEventEdit
}>()

const dateStart = ref(getDateFormatted(props.eventData.dateStart).slice(0, 10) || '')
const dateEnd = ref(getDateFormatted(props.eventData.dateEnd).slice(0, 10) || '')
const timeStart = ref(getTimeFormatted12Hours(props.eventData.dateStart) || '12:00')
const timeEnd = ref(getTimeFormatted12Hours(props.eventData.dateEnd) || '12:00')
</script>

<template>
  <div class="view-event">
    <v-row>
      <v-col cols="2">
        <p class="view-event__bold-title">Start:</p>
      </v-col>
      <v-col cols="5">
        <p>
          <v-icon>{{ mdiCalendarCheckOutline }}</v-icon>
          {{ dateStart }}
        </p>
      </v-col>
      <v-col cols="5">
        <p>
          <v-icon>{{ mdiClockOutline }}</v-icon>
          {{ timeStart }}
        </p>
      </v-col>
      <v-col cols="2">
        <p class="view-event__bold-title">End:</p>
      </v-col>
      <v-col cols="5">
        <p>
          <v-icon>{{ mdiCalendarCheckOutline }}</v-icon>
          {{ dateEnd }}
        </p>
      </v-col>
      <v-col cols="5">
        <p>
          <v-icon>{{ mdiClockOutline }}</v-icon>
          {{ timeEnd }}
        </p>
      </v-col>
    </v-row>
  </div>
</template>

<style lang="scss" scoped>
.view-event {
  max-width: 400px;
  margin: 0 auto;

  &__bold-title {
    font-weight: var(--font-weight-semi-bold);
  }
}
</style>
